<template>
  <div>
    <div class="content_center">
      <div class="content_center-center active">
        <template >
          <div  v-loading="loading" 
          element-loading-text="视频加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          
          class="content_video_box" ref="playing_video" >
            <tc-player
            v-if="!noData"
              ref="tcplayer"
              :playVideo="playVideo"
              :index="current"
              :widthHeigt="[100, 100]"
            ></tc-player>
          </div>
       
        <!-- <el-carousel :interval="5000"
                 :height="200"
                    arrow="always">
          <el-carousel-item v-for="(item,index) in siwperData"
                            :key="index"
                            style="height: 200px">
            <el-row class="onlineList">
              <el-col v-for="(i,n) in item"
                      class="onlineItem"
                      :key="n"
                      :span="5"
                      @click="changeOnline(i)">
                {{i.videoAddress }}
              </el-col>

            </el-row>
          </el-carousel-item>
        </el-carousel> -->
        </template>
        <!-- <template v-else>
          <div class="content_video_box no-play-video">暂无数据</div>
        </template> -->
      </div>
    </div>
    <div class="center_right">
        <!-- <div class="begin" @click="beginSwiper">{{begin ?'停止轮播':'开启轮播'}} 
      <el-switch v-model="begin" active-color="#13ce66" inactive-color="#ff4949"></el-switch>

        </div> -->

       <template>
        <div
          class="video-list-li"
          v-for="(item, index) in playVideoList"
          ref="video_list"

          :key="index"
          @click="getVideo(item,index)"
        >
          <div class="mask"></div>
          <div :class="{ nowVideo: index==current }" style="display: flex;align-items: center;"> 
            <img v-if="index==current" src="@/assets/img/drillCenter/greenSvg.svg" style="width: 25px;height: auto;margin:0  6px 6px 0;" alt="">

            <img v-else src="@/assets/img/drillCenter/whiteSvg.svg" style="width: 25px;height: auto;margin:0  6px 6px 0;" alt="">
            {{ item.videoAddress }}</div>
        <!--  <tc-player-unit
            :ref="'tcplayer' + index"
            :index="index"
            :playVideo="item"
            :widthHeigt="[100, 100]"
          ></tc-player-unit> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import TcPlayer from "./TcPlayer.vue";
import TcPlayerUnit from "./TcPlayerUnit.vue";
export default {
  name: "DrillCenterMonitor",
  components: {
    TcPlayer,
    TcPlayerUnit
  },
  props: {
    playVideoList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      playVideo: {},
      canplayVideoList:[],
      current:0,
      begin:false,
      timer:null,
      loading:false,
      noData:false
    };
  },
  created() {},
  mounted() {
    // console.log(this.playVideoList);
    // this.modify();
  },
  computed: {},
  watch: {
    playVideoList: function(newVal) {
      console.log(newVal)
      this.modify();
     
    },
    immediate: true,
    deep:true

    
  },
  methods: {
    modify () {
      let video = this.playVideoList
      if(video.length){
        this.noData= false

        let data = {
            code:video[0].code,
            streamType: 1,
            forceH264: true,
          }
          this.getPlayUrls(data, this.playVideoList[0])
      }else{
        this.noData= true
      }
      
      // for (var i = 0; i < videoList.length; i++) {
      //   if (videoList[i].isPull != 0) {
      //     // this.$message.error('请检查摄像头网络')
          
      //     // let results = await this.$playHttp.getPlayUrl(data)


      //     // this.showPlayList(playVideoList);
      //   }
      // }
      
      // console.log(this.playVideoList);
      if (this.playVideoList.length > 0) {
        // 默认选中第一个监控
        // this.playVideo = this.playVideoList[0];
      }
    },
    beginSwiper(){
      if(this.begin){
        this.begin=false
        clearInterval(this.timer)
        this.timer=null
        return
      }
      this.begin=true
      this.timer = setInterval(() => {
        if( this.current==this.canplayVideoList.length-1){ this.current=0}else{
          this.current++

        } 
        

      }, 10000);
    },
    getPlayUrls (data, i) {
      this.loading=true
      this.$playHttp.getPlayUrl(data).then(results => {
        this.loading=false
        this.noData=false
        if (results.data.errno == 0) {
          this.playVideo= {
            playStatus: true,
            id: "video-" + i,
            // m3u8_sd: videoList[i].hls,
            m3u8_hd: 'wss://vs.zzsasoft.com' + results.data.data.flv,
            // flv_sd: videoList[i].flv,
            // flv_hd: videoList[i].flvHd,
            videoAddress: results.data.data.name,
            addressName:i.videoAddress,
          

          }
        // = this.canplayVideoList[0]
        } else {
          this.noData=true
          // this.canplayVideoList.splice(i, 1, {
          //   // playVideoList.push({
          //   playStatus: false,
          //   id: "video-" + i,
          //   info: '摄像头未推流'
          // });
          this.$message.error('请检查摄像头网络')
        }
      })
    },
    getVideo(item,index) {
      let data = {
            code:  item.code,
            streamType: 1,
            forceH264: true,
          }

      this.getPlayUrls(data,item,item.videoAddress)
      this.current=index
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.content_center {
  height: 100%;
  width: 75%;
  float: left;
  position: relative;
  .content_center-center {
    overflow: hidden;
    opacity: 0;
    width: 100%;
    height: 0;
    position: absolute;
    left: 0;
    top: 0;
    &.active {
      height: 100%;
      opacity: 1;
      /deep/ .content_video_box {
        height: 100%;
      }
    }
  }
  /deep/ .content_video_box {
    width: 100%;
    height: 0;
    float: left;
    position: relative;
    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
      video {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }
    video {
      width: 100%;
      height: 100%;
    }
    &.no-play-video {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.center_right {
  width: 25%;
  height: 100%;
  float: right;
  // background-color: #191919;
  background-image: url('~@/assets/img/drillCenter/right_bottom.png');
  background-size: 100% 100%;
  padding: 1rem;
  overflow-y: auto;
  padding: 0 2rem 2rem;
}
.begin{
  margin: 20px 0 0 0;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}
.video-list-li {
  width: 100%;
  height: 60px;
  overflow: hidden;
  float: left;
  background-image: url('~@/assets/img/drillCenter/lefttop.png');
  background-size: 100% 100%;  padding:0 2rem ;
  line-height: 60px;
  cursor: pointer;
  margin-top:10px;
  font-size: 14px;
  position: relative;
  color: #fff;
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1005;
  }
  /deep/ .video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  /deep/ video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    background: rgba(0, 0, 0, 0.5);
  }
  .video-address {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding: 5px;
  }
}
.nowVideo{
  color: #21bf25;
  opacity: 1;
}
</style>
